import styled from 'styled-components';

export const ContainerIcon = styled.div`
    & svg {
        cursor: not-allowed !important;
    }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
